<template>
  <div class="main-container email-previews-page">
    <h1 class="ui header">Email template previews</h1>
    <p class="email-previews-intro">Use these links to preview how transactional emails will look. Opens in a new tab. Ensure the backend is running (e.g. <code>npm run dev:backend</code>) so the preview API is available.</p>
    <div class="ui relaxed list">
      <div class="item" v-for="t in templates" :key="t.id">
        <div class="content">
          <a :href="previewUrl(t.id)" target="_blank" rel="noopener" class="header">{{ t.name }}</a>
          <div class="description">{{ t.description }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EmailPreviews',
  data() {
    return {
      templates: [
        { id: 'password-reset', name: 'Forgot password', description: 'Password reset request with logo placeholder, heading, body and CTA button.' },
        { id: 'verification', name: 'Verification', description: 'Account verification email (legacy style; will be updated for consistency).' },
        { id: 'quote', name: 'Quote', description: 'Quote email with shared styles; Review & Accept button and Powered by Smardie footer.' },
        { id: 'invoice', name: 'Invoice', description: 'Invoice email with shared styles; View Invoice button and Powered by Smardie footer.' }
      ]
    };
  },
  methods: {
    previewUrl(templateId) {
      // Use env base URL when set (local and DO both end with /api), so path is /email/preview/... not /api/email/preview/...
      const base = process.env.VUE_APP_BASE_URL ? String(process.env.VUE_APP_BASE_URL).replace(/\/$/, '') : '';
      const path = base && base.endsWith('/api') ? `/email/preview/${templateId}` : `/api/email/preview/${templateId}`;
      return base ? `${base}${path}` : path;
    }
  }
};
</script>

<style scoped>
.email-previews-page { padding: 1rem 0; }
.email-previews-intro { margin-bottom: 1.5rem; color: var(--color-mid-grey); }
.email-previews-intro code { background: var(--color-very-light-grey); padding: 2px 6px; border-radius: 4px; }
.email-previews-page .list .item .header { font-size: 1.1rem; }
</style>
